import { render, staticRenderFns } from "./cobranzasFiltroLocalVentas.vue?vue&type=template&id=bf630122"
import script from "./cobranzasFiltroLocalVentas.vue?vue&type=script&lang=js"
export * from "./cobranzasFiltroLocalVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports